<template>
  <div class="account-integrations">
    <MainHeader
        class="account-integrations__header"
        title="Интеграции аккаунтов"
        btnText="Добавить интеграцию"
        :number="integrationsList?.integrations?.length || 0"
        @btnClick="openIntegrations"
    />

    <VSegmentedControlQuery class="account-integrations__tabs" :items="filteringOptions" />

    <div class="account-integrations__cards">
      <IntegrationCard
          class="account-integrations__card"
          v-for="card in integrationsList"
          :key="card.id"
          :card="card"
          :updateKeyList="updateKeyList"
          @editIntegrationsOpenModal="editIntegrationsOpenModal"
          @updateKey="updateKey"
          @delete="deleteIntegrations"
      />
    </div>
    <div class="skeleton-block">
      <VSkeleton style="width: 352px!important;" v-if="skeleton" v-for="item in  [...Array(9).keys()]" height="91" variants="CARD"/>
    </div>
    <div class="account-integrations__no-content" v-if="integrationsList?.length < 1 && !skeleton">
      <VNoContent title="Список интеграций пуст" description="Вы еще не добавили интеграции" />
    </div>

<!--    <div-->
<!--        class="account-integrations__pagination"-->
<!--        v-if="integrationsList.pages_count > 1 && integrationsList.length"-->
<!--    >-->
<!--      <VButton-->
<!--          class="account-integrations__pagination-btn"-->
<!--          label="Загрузить еще"-->
<!--          bg="#0D5FCB1A"-->
<!--          color="#0086B2"-->
<!--          bgHover="#0D5FCB4D"-->
<!--          colorHover="#0086B2"-->
<!--          @click="loadMore()"-->
<!--          v-if="page < integrationsList?.pages_count && showPagination"-->
<!--      />-->
<!--      <VPaginate-->
<!--          :pageCount="integrationsList?.pages_count"-->
<!--          :modelValue="page"-->
<!--          @update:modelValue="pagination"-->
<!--          class="account-integrations__pagination-pag"-->
<!--      />-->
<!--    </div>-->


    <ModalWindow class="account-integrations__modal-add" v-if="dialogAdd" :show="dialogAdd">
      <IntegrationAdd
          :addIntegrationsError="addIntegrationsError"
          :updateKeyItem="updateKeyItem"
          @close="closeDialogAdd"
          @add="addIntegrations"
          @delete="deleteIntegrationsOpenModal"
          :editData="editData"
      />
    </ModalWindow>

    <ModalWindow class="account-integrations__modal-delete"
                 v-if="dialogDelete"
                 :show="dialogDelete">
      <IntegrationDelete @close="dialogDelete = false" @delete="deleteIntegrations"
                         :deleteIntegrationsName="deleteIntegrationsName"/>
    </ModalWindow>
  </div>
</template>
<script setup>

import MainHeader from "@/components/MainHeader/index.vue";
import IntegrationCard from "@/components/Integration/IntegrationCard/index.vue";
import IntegrationAdd from "@/components/Integration/IntegrationAdd/index.vue";
import IntegrationDelete from "@/components/Integration/IntegrationDelete/index.vue";
import externalIntegrations from "@/api/externalIntegrations";
import {computed, onMounted, onUnmounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import VPaginate from "@/components/UI/VPaginate/index.vue";
import vacancies from "@/api/vacancies";
import VSkeleton from "@/components/UI/VSkeleton/index.vue";
import VSegmentedControlQuery from "@/components/UI/VSegmentedControlQuery/index.vue";

const dialogAdd = ref(false)
const dialogDelete = ref(false)
const deleteIntegrationsName = ref('')
const deleteIntegrationsId = ref('')
const integrationsList = ref([])
const updateKeyList = computed(() => {
  let keyList = []
  integrationsList.value.forEach((item) => {
    keyList.push(item.id)
  })
  return keyList
})
const updateKeyItem = ref(null)
const router = useRouter();
const route = useRoute();

const filteringOptions = [
  {
    id: "hh",
    label: "Headhunter",
  },
  {
    id: "avito",
    label: "Avito",
  },
];

const updateKey = async (item) => {
  if(route.query?.tabs === "avito") {
    await externalIntegrations.updateExternalIntegrations(item, item?.id)
  }
  if(route.query?.tabs === "hh") {
    await externalIntegrations.updateHeadHunter(item, item?.id)
  }
}
const closeDialogAdd = () => {
  dialogAdd.value = false;
  updateKeyItem.value = null
}
const skeleton = ref(false)
// const page = ref(1);
const upPageOffset = ref(true)
const pageOffset = ref(0)
const windowHeight = ref(0)
const updateWindowSize = () => {
  windowHeight.value = window.innerHeight;
}
const addIntegrationsError = ref('Заполните обязательное поле')
const pageLimit = computed(() => {
  if(windowHeight.value <= 600) return 12
  if(windowHeight.value <= 900) return 24
  return 32
})
// const showPagination = ref(true)
// const pagination = (val) => loadMore(val);
//
// const loadMore = async (num) => {
//   showPagination.value = false
//   page.value = num ? num : page.value + 1;
//
//   const params = {
//     // search: search.value ? search.value : "",
//     page: page.value,
//   };
//
//   // if (activeFilter.value === "draft") params.is_draft = 1
//
//   try {
//     const response = await externalIntegrations.getExternalIntegrations(params)
//
//     if (num) integrationsList.value = [];
//     integrationsList.value.push(...response);
//     showPagination.value = true
//   } catch (error) {
//     console.log(error);
//   }
// };


const getIntegrations = async (outerParams, isAdd = false) => {
  if (isAdd) {
    pageOffset.value += pageLimit.value;
  } else {
    pageOffset.value = 0;
  }

  const params = {
    limit: pageLimit.value,
    offset: pageOffset.value
  }

  try {
    skeleton.value = true
    let items = []
    if(route.query?.tabs === "avito") {
      items = await externalIntegrations.getExternalIntegrations({...params})
    }
    if(route.query?.tabs === "hh") {
      items = await externalIntegrations.getHeadHunter({...params})
    }

    skeleton.value = false
    if(items?.integrations?.length > 0) {
      integrationsList.value = items?.integrations
      upPageOffset.value = true
    }
  } catch (error) {
    console.log(error)
  }
}

const addIntegrations = async (args) => {
  try {
    // /frontend/api/external-integrations/:id
    integrationsList.value = []
    const content = await externalIntegrations.addExternalIntegrations(args);
    if(content?.status === "Ok") {
      await getIntegrations()
      dialogAdd.value = false
    }
  } catch (error) {
    console.log(error, 'log')
    addIntegrationsError.value = error?.response?.data?.error_message;
  }
}

const deleteIntegrationsOpenModal = async (args) => {
  if(route.query?.tabs === "avito") {
    deleteIntegrationsId.value = args.delete_id
    deleteIntegrationsName.value = args.name
    dialogDelete.value = true
  }

  if(route.query?.tabs === "hh") {
    await externalIntegrations.deleteHeadHunter(deleteIntegrationsId.value)
  }
}
const editData = ref({})
const editIntegrationsOpenModal = async (id, name, client_secret, delete_id) => {
  if(route.query?.tabs === "avito") {
    dialogAdd.value = true
    editData.value = {
      id,
      name,
      client_secret,
      delete_id
    }
  }
  if(route.query?.tabs === "hh") {
    // const content = await externalIntegrations.addHeadHunterIntegration()
    // window.open(content?.url, '_self');
  }
}


const deleteIntegrations = async (id) => {
  try {
    if(route.query?.tabs === "avito") {
      await externalIntegrations.deleteExternalIntegrations(deleteIntegrationsId.value)
    }
    if(route.query?.tabs === "hh") {
      await externalIntegrations.deleteHeadHunter(id)
    }
    await getIntegrations()
  } catch (error) {
    console.log(error)
  }
  dialogDelete.value = false
  dialogAdd.value = false
}

const store = useStore();
const role = store.getters["auth/role"];



const handleWindowScroll = () => {
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  const windowHeight = window.innerHeight;
  const documentHeight = document.documentElement.scrollHeight;

  const isBottom = scrollTop + windowHeight >= documentHeight - 100; // -100 для небольшого запаса

  if (isBottom && upPageOffset.value) {
    getIntegrations({}, true)
    upPageOffset.value = false
  }
};

const openIntegrations = async () => {
  if(route.query?.tabs === "avito") {
    dialogAdd.value = true
  }
  if(route.query?.tabs === "hh") {
    const content = await externalIntegrations.addHeadHunterIntegration()
    window.open(content?.url, '_self');
  }
}

onMounted(() => {
  window.addEventListener('scroll', handleWindowScroll);
  updateWindowSize()
  window.addEventListener('resize', updateWindowSize);
  if (role !== 'ADMIN') {
    router.push("/");
  }
  getIntegrations({offset: 0})
})

watch(() => route.query?.tabs, () => {

  integrationsList.value = []
  getIntegrations({offset: 0})
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleWindowScroll);
  window.removeEventListener('resize', updateWindowSize);
});

</script>
<style scoped  lang="scss">
.account-integrations {
  color: $dark;

  &__header {
    margin-top: 32px;
  }

  :deep(.main-header__title-number) {
    font-size: 16px;
    font-weight: 700;
    color: $gray;
  }

  &__cards {
    display: flex;
    flex-wrap: wrap;
    gap: 24px 32px;
    margin-top: 24px;
    margin-bottom: 24px;
  }

  &__card {
    width: 352px;
  }

  &__no-content {
    width: 100%;
    height: calc(70vh - 143px);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__modal-delete {
    :deep(.modal__body) {
      width: 352px;
    }
  }

  &__modal-add {
    :deep(.modal__body) {
      width: 514px;
    }
  }


  &__pagination {
    position: relative;
    width: 100%;
    height: 48px;
    margin-top: 32px;
    display: flex;
    justify-content: center;
  }

  &__pagination-btn {
    width: 156px;
    padding: 0 10px;
    font-weight: 400;
    border-radius: 8px;

    &:active {
      background-color: #0D5FCB80 !important;
    }
  }

  &__pagination-pag {
    position: absolute;
    top: 0;
    right: 0;
  }

  &__tabs {
    margin: 24px 0;
    width: 640px;
  }

  .skeleton-block {
    display: flex;
    flex-wrap: wrap;
    gap: 0 32px;
    margin-left: -32px;
    margin-top: -44px;
  }
}
</style>